/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'โฮม',
	homePageTabsLabel: 'เนื้อหาหลัก',
	myContent: 'เนื้อหาของฉัน',
	teamContent: 'เนื้อหาทีม',
	folder: 'โฟลเดอร์',
	files: 'ไฟล์',
	actionMenu: 'เมนูแอ็คชัน',
	myFolder: 'โฟลเดอร์ของฉัน',

	emptyFolderNoContent: 'ไม่มีเนื้อหา',

	//EmptyStates
	emptyRecentTitle: 'คุณไม่ได้ดูเนื้อหาใด ๆ เมื่อเร็ว ๆ นี้',
	emptyStateTitle: 'เริ่มต้นโดยการเพิ่มข้อมูล',
	emptyStateBody: 'คลิกอัพโหลดข้อมูลข้างบนหรือลากและปล่อยเพื่ออัพโหลดข้อมูล',
	emptySearchResultTitle: 'ขออภัย การค้นหาของคุณไม่ได้ผลลัพธ์ใด ๆ',
	emptyPortalTitle: 'ไม่มีพอร์ทัล',
	emptyPortalBody: 'คุณไม่มีพอร์ทัลใด ๆ ในขณะนี้',
	emptyWsProjectTitle: 'เริ่มต้นโดยการสร้างโน้ตบุ๊กใน Watson Studio',
	emptyWsProjectBody: 'เมื่อคุณกลับไปที่ Cognos Analytics โน้ตบุ๊กของคุณจะปรากฏที่นี่',
	emptyFilteredResultTitle: 'ขออภัย ตัวกรองที่ใช้ไม่ได้ให้ผลลัพธ์ใด ๆ',
	emptyDialogViewTitle: 'ไม่มีไอเท็ม',
	removeFromRecents: 'ลบออกจากที่ผ่านมา',

	// Welcome Banner
	welcomeBannerGreeting: 'สวัสดี ยินดีต้อนรับสู่ Cognos Analytics with Watson',
	welcomeBannerDescription: 'Cognos Analytics with Watson เพิ่มพลังให้ผู้ใช้ด้วยการวิเคราะห์แบบบริการตนเองที่ขับเคลื่อนด้วยเทคโนโลยี AI ดูวิธีการเตรียมข้อมูลแบบอัตโนมัติ การค้นหาข้อมูล และการแสดงภาพซึ่งสามารถขับเคลื่อนให้เกิดการตัดสินใจที่มั่นใจได้มากขึ้น',
	welcomeBannerDescription_trialUser: 'คุณสามารถเริ่มต้นได้โดยดูวิดีโอบทนำของเรา การแนะนำผลิตภัณฑ์ และแท็บเริ่มต้นใช้งาน',
	takeTourButtonLabel: 'ดูข้อมูลผลิตภัณฑ์',
	watchVideoButtonLabel: 'ดูวิดีโอ',
	// confirmation dialog
	hideWelcomeBannerMsg: 'คุณแน่ใจว่าต้องการปิดแบนเนอร์ยินดีต้อนรับจากโฮมเพจของคุณ? คุณสามารถเปิดแบนเนอร์ได้อีกครั้งใน โปรไฟล์และการตั้งค่า > การตั้งค่า > ทั่วไป ได้ตลอดเวลา ',
	hideWelcomeBannerTitle: 'ปิดแบนเนอร์ยินดีต้อนรับ',
	ok: 'ตกลง',
	cancel: 'ยกเลิก',
	warn: 'คำเตือน',
	//howto video dialog
	modal_how_title: 'ดูภาพรวม Cognos Analytics',
	modal_overview_title: 'ดูภาพรวม Cognos Analytics',
	modal_how_play: 'เล่นวิดีโอ',
	modal_how_video_title_overview: 'ภาพรวม',
	modal_how_video_title_getStarted: 'เริ่มต้นใช้งานใน 11.2',
	modal_how_video_title_newUI: 'ขอต้อนรับสู่ประสบการณ์ใหม่ของ Cognos',
	modal_how_video_title_dataModule: 'ภาพรวมของโมดูลข้อมูล',
	modal_how_video_title_explore: 'ภาพรวมของการสำรวจข้อมูล',
	modal_how_video_title_dashboard: 'ภาพรวมของแดชบอร์ดแบบโต้ตอบ',
	modal_how_video_title_reporting: 'ภาพรวมของการรายงาน',
	modal_how_video_title_mobile: 'พลังของ Cognos บนฝ่ามือของคุณ',

	// Toolbar
	search: 'ค้นหา',
	addFolder: 'เพิ่มโฟลเดอร์',
	addLink: 'เพิ่มลิงก์',
	filter: 'ตัวกรอง',
	sort: 'เรียงลำดับ',
	settings: 'การตั้งค่า',
	tilesView: 'มุมมองแบบซ้อน',
	listView: 'มุมมองรายการ',
	columnView: 'มุมมองแบบคอลัมน์',
	backToSearch: 'กลับไปที่ผลการค้นหา',

	// Toolbar Actions
	sortBy: 'เรียงลำดับโดย',
	sortOrder: 'ใบสั่ง',
	name: 'ชื่อ',
	modifiedTime: 'ปรับเปลี่ยน',
	type: 'ชนิด',
	ascending: 'น้อยไปหามาก',
	descending: 'จากมากไปหาน้อย',
	resetSort: 'รีเซ็ตการจัดเรียง',

	filterType: 'ชนิด',
	filterModificationTime: 'ปรับเปลี่ยน',
	all: 'ทั้งหมด',
	today: 'วันนี้',
	yesterday: 'เมื่อวานนี้',
	pastWeek: 'สัปดาห์ที่ผ่านมา',
	pastMonth: 'เดือนที่ผ่านมา',
	resetFilters: 'รีเซ็ตตัวกรอง',
	resultLimit: 'ค่าจำกัดผลลัพธ์',

	filterSearchPlaceHolder: 'กรองตามคีย์เวิร์ด',

	resetFilterTag: 'คลิก X เพื่อรีเซ็ตตัวกรอง',
	filterTagToolTip: 'ใช้ตัวกรอง: %{appliedFilters}',

	folderName: 'ชื่อโฟลเดอร์',
	addAFolder: 'เพิ่มโฟลเดอร์',
	add: 'เพิ่ม',
	error: 'ข้อผิดพลาด',
	newFolderDefaultName: 'สร้างโฟลเดอร์ใหม่',
	toastCreateNewFolder: 'โฟลเดอร์ %{nameOfFolder} ถูกสร้างขึ้นแล้วใน %{tabName}',
	folderAdded: 'เพิ่มโฟลเดอร์แล้ว',
	refresh: 'รีเฟรช',
	openFolder: 'เปิดโฟลเดอร์',

	addAUrl: 'เพิ่ม URL',
	linkName: 'ชื่อ URL',
	linkNamePlaceholder: 'เพิ่มชื่อ URL',
	linkDescription: 'คำอธิบาย (ทางเลือก)',
	linkDescriptionPlaceholder: 'เพิ่มคำอธิบาย',
	linkUri: 'URL',
	linkUriPlaceholder: 'เพิ่ม URL ที่มีโดเมนที่ยอมรับได้',
	acceptableDomains: 'โดเมนที่ยอมรับได้',
	viewAcceptableDomains: 'ดูโดเมนที่ยอมรับได้',
	mandatoryField: 'ฟิลด์บังคับ',
	linkAdded: 'เพิ่ม URL แล้ว',
	toastCreateNewLink: '%{nameOfLink} ถูกเพิ่มไปยัง %{tabName}',
	noEntries: 'ไม่มีรายการในรายการโดเมนที่ยอมรับได้ โปรดติดต่อผู้ดูแลระบบของคุณ',
	unacceptableDomain: 'URL ของคุณใช้โดเมนที่ไม่ถูกต้อง คลิก \'ดูโดเมนที่ยอมรับได้\' เพื่อดูรายชื่อโดเมนที่คุณสามารถใช้ได้',

	compact: 'กะทัดรัด',
	short: 'สั้น',
	default: 'ดีฟอลต์',
	rowSize: 'ขนาดแถว',

	// GroupyByTypes
	folders: 'โฟลเดอร์',
	reports: 'รายงาน',
	dashboards: 'แดชบอร์ด',
	data: 'ข้อมูล',
	packages: 'แพ็กเกจ',
	explorations: 'การสำรวจ',
	stories: 'เรื่องราว',
	notebooks: 'โน้ตบุ๊ก',
	others: 'อื่น ๆ',

	// Error Messages
	itemsOverLimit: 'ชื่อที่ระบุ "%{itemName}" เกินขีดจำกัดสูงสุด (20) โปรดระบุชื่ออื่นเพื่อดำเนินการต่อ',
	errorMessageLengthFolderName: 'โปรดป้อนชื่อโฟลเดอร์ที่ไม่เกิน 255 อักขระ',
	errorMessageLengthLinkName: 'โปรดป้อนชื่อลิงก์ที่มีอักขระไม่เกิน 255 ตัวอักษร',
	toastLaunchPerspectiveError: 'ไม่สามารถเปิด %{objectType}',
	errorNoAccessTitle: 'ขออภัย คุณไม่มีสิทธิเข้าถึงเนื้อหานี้',
	errorNoAccessBody: 'โปรดติดต่อผู้ดูแลระบบของคุณหรืออ้างถึงลิงก์ต่อไปนี้:',
	errorEnableExternalContent: 'การเปิดใช้งานเนื้อหาภายนอก',

	//TableHeader
	lastAccessed: 'เข้าถึงล่าสุด',
	location: 'ที่ตั้ง',
	tenant: 'ผู้เช่า',

	// GetStartedTab
	getStartedLabel: 'เริ่มต้นและรันใน IBM Cognos Analytics',
	learningHowToLabel: 'รีซอร์สการเรียนรู้',
	learningHowToDescription: 'เพิ่มพูนความรู้ของคุณและรับความช่วยเหลือโดยเชื่อมต่อกับชุมชน อ่านเอกสารคู่มือ และดูวิดีโอ',
	learningHowToActionLabel: 'เรียกใช้บานหน้าต่างการเรียนรู้',
	howToVideosLabel: 'วิดีโอวิธีการ',
	howToVideosDescription: 'ศึกษาวิธีการใช้ IBM Cognos Analytics และเริ่มต้นรับข้อมูลเชิงลึกในข้อมูลของคุณ',
	howToVideosActionLabel: 'ดูวิดีโอ',
	acceleratorCatalogLabel: 'แค็ตตาล็อก Accelerator',
	acceleratorCatalogDescription: 'เรียกดูแค็ตตาล็อกที่เพิ่มขึ้นของการใช้งานอุตสาหกรรม คำแนะนำเกี่ยวกับแนวทางปฏิบัติที่ดีที่สุด การแสดงภาพแบบกำหนดเอง และอื่น ๆ',
	acceleratorCatalogActionLabel: 'เรียกดูแค็ตตาล็อก',
	sampleSectionTitle: 'ตัวอย่าง',
	sampleSectionDescription: 'ทดลองกับตัวอย่างที่แสดงให้เห็นทั้งหมดที่ Cognos Analytics มีให้',
	// Samples Section
	createDashboardSampleTitle: 'วิธีการสร้างแดชบอร์ดแรกของคุณ',
	createDashboardSampleDescription: 'เริ่มต้นการเดินทางวิเคราะห์ข้อมูลของคุณด้วย Cognos Dashboards',
	nlaSampleTitle: 'รายงานตัวอย่าง',
	nlaSampleDescription: 'สำรวจสิ่งที่เป็นไปได้ด้วยรายงานCognos Analyticsที่มีตัวอย่างนี้ในการวิเคราะห์กิจกรรมสมาชิกบัตรสะสมคะแนนในช่วงสิ้นปี',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'ขยายไลบรารีการแสดงภาพของคุณด้วยการแสดงภาพแบบกำหนดเอง เช่น Sankey Chart',
	viewAllSamplesActionLabel: 'ดูตัวอย่างทั้งหมด',
	byFeatureTitle: 'ตามคุณลักษณะ',
	byFeatureDescription: 'เรียกดูตัวอย่างตามคุณลักษณะ เช่น ฟังก์ชันหลักตัว ตัวควบคุมแบบกำหนดเอง ส่วนขยาย โน้ตบุ๊ก และวันที่ที่เกี่ยวข้อง',
	byIndustryTitle: 'ตามอุตสาหกรรม',
	byIndustryDescription: 'เรียกดูตัวอย่างตามอุตสาหกรรม เช่น ยานยนต์ ธนาคาร และอื่น ๆ',
	// SamplesTab
	sampleTabTitle: 'รับแรงบันดาลใจจากตัวอย่างของเรา',
	sampleTabLabel: 'เยี่ยมชม Accelerator Catalog สำหรับตัวอย่างและส่วนขยายเพิ่มเติมจาก IBM, คู่ค้า และลูกค้า',

	// quickLaunch
	quickLaunchLabel: 'เรียกใช้งานด่วน',
	expand: 'ขยาย',
	collapse: 'ยุบ',

	// quickLaunch dialog
	quickLaunchModalLabel: 'เริ่มต้นโดยเลือกสิ่งที่คุณต้องการสร้าง',

	// contentPageView
	contentPageTitleLabel: 'เนื้อหา',
	uploadFile: 'อัพโหลดข้อมูล',
	new: 'สร้าง',
	create: 'สร้าง',
	more: 'เพิ่มขึ้น',

	// open dialog
	selectDataSourcesToAdd: 'เลือกแหล่งข้อมูลที่จะเพิ่ม',
	openDialogDefaultTitle: 'เปิด',

	// save dialog
	save: 'บันทึก',
	saveAs: 'บันทึกเป็น',
	saving: 'กำลังบันทึก...',
	selectedDestination: 'ปลายทางที่เลือก: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' มีอยู่ก่อนแล้วในชนิดอื่น โปรดเลือกชื่ออื่น',
	confirmOverwriteTitle: 'ยืนยันการเปลี่ยนข้อมูลเดิม',
	confirmOverwriteMsg: 'ไฟล์ \'%{nameOfFile}\' มีอยู่ก่อนแล้ว คุณต้องการแทนที่ข้อมูลด้วยข้อมูลซึ่งมีอยู่ในไฟล์ที่เลือกหรือไม่?',

	// copy move dialog
	copy: 'คัดลอก',
	move: 'ย้าย',
	copyOrMove: 'คัดลอกหรือย้าย: ',
	copyOnly: 'คัดลอก ',
	createShortcut: 'สร้างช็อตคัต',
	createShortcutDialogTitle: 'สร้างช็อตคัต: ',

	// External asset types
	wsProject: 'โปรเจ็กต์ Watson Studio',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'แพ็กเกจ',
	dataModule: 'โมดูลข้อมูล',
	exploration: 'การสำรวจ',
	mode: 'โหมด',
	live: 'สด',
	snapshot: 'สแน็ปช็อต',
	noSnapshotsFound: 'ไม่พบสแน็ปช็อต',
	uploadedFile: 'ไฟล์ที่อัพโหลด',
	fileUpload: 'อัพโหลดข้อมูล',
	dataSetEx: 'ชุดข้อมูล',
	externalRepository: 'ที่เก็บข้อมูลภายนอก',
	queryMode: 'โหมดเคียวรี',
	queryModeCompatible: 'ทำงานร่วมกันได้',
	queryModeDynamic: 'ไดนามิก',
	report: 'รายงาน',
	activeReport: 'รายงานที่แอ็คทีฟ',
	query: 'เคียวรี',
	analysis: 'การวิเคราะห์',
	dashboard: 'แดชบอร์ด',
	dashboardTemplate: 'เท็มเพลตแดชบอร์ด',
	jupyterNotebook: 'โน้ตบุ๊ก',
	wsNotebook: 'โน้ตบุ๊ก Watson Studio',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'เรื่องราว',
	workspace: 'เวิร์กสเปซ',
	pagelet: 'หน้า',
	content: 'เนื้อหา',
	directory: 'เนมสเปซ',
	dataSet: 'ชุดข้อมูล',
	powerPlayCube: 'คิวบ์ PowerPlay',
	powerPlayReport: 'รายงาน PowerPlay',
	powerPlay8Report: 'รายงาน PowerPlay',
	setPowerPlay8ReportOptions: 'ตั้งค่าตัวเลือกรายงาน PowerPlay',
	powerPlay8ReportView: 'มุมมองรายงาน PowerPlay',
	reportTemplate: 'เท็มเพลตรายงาน',
	packageConfigurations: 'คอนฟิกูเรชันแพ็กเกจ',
	agent: 'เอเจนต์',
	agentDefinition: 'คำนิยามเอเจนต์',
	agentDefinitionView: 'มุมมองเอเจนต์',
	dataMovementTask: 'ภารกิจการย้ายข้อมูล',
	dataMovementTaskAlias: 'สมนามของภารกิจการย้ายข้อมูล',
	document: 'เอกสาร',
	DocumentRetention: 'คุณสมบัติเอกสาร',
	jobDefinition: 'นิยามงาน',
	job: 'งาน',
	jobs: 'งาน',
	metricsDataSourceETLTask: 'ภารกิจ ETL แหล่งข้อมูลเมทริก',
	metricsExportTask: 'ภารกิจการเอ็กซ์พอร์ตเมทริก',
	metricsFileImportTask: 'ภารกิจการอิมพอร์ตไฟล์เมทริก',
	metricsMaintenanceTask: 'ภารกิจการบำรุงรักษาเมทริก',
	planningTask: 'ภารกิจการวางแผน',
	shortcut: 'ช็อตคัต',
	shortcuts: 'ช็อตคัต',
	URL: 'URL',
	launchable: 'เรียกใช้ได้',
	dataSetFolder: 'โฟลเดอร์ชุดข้อมูล',
	ViewAccessibleLabel: 'ดู %{label}',
	overrideReportOptions: 'ลบล้างอ็อพชันรายงานดีฟอลต์',
	formats: 'รูปแบบ',
	saveReport: 'บันทึกรายงาน',
	reportView: 'มุมมองรายงาน',
	reportviews: 'มุมมองรายงาน',
	html: 'HTML',
	pdf: 'PDF',
	spreadsheetML: 'Excel',
	xlsxData: 'ข้อมูล Excel',
	csv: 'CSV',
	xml: 'XML',
	txt: 'TXT',
	role: 'บทบาท',
	namespace: 'เนมสเปซ',
	namespaceFolder: 'โฟลเดอร์เนมสเปซ',
	adminFolder: 'โฟลเดอร์แอดมิน',
	//Details
	details: 'รายละเอียด',
	open: 'เปิด',
	created: 'สร้าง',
	modified: 'ปรับเปลี่ยน',
	owner: 'เจ้าของ',
	dataSource: 'แหล่งข้อมูล',
	share: 'แบ่งใช้',
	addToFavorites: 'เพิ่มไปยังรายการโปรด',
	properties: 'คุณสมบัติ',
	detailsEmptyStateBody: 'เลือกไอเท็มที่จะดูรายละเอียด',
	editNameAndDescription: 'แก้ไขชื่อและคำอธิบาย',
	none: 'ไม่มี',
	setPdfOptions: 'ตั้งค่าอ็อพชัน PDF',
	runOptions: 'อ็อพชันการรัน',

	//rename dialog
	nameInvalid: 'ชื่อไม่ถูกต้อง',
	namePlaceholder: 'ป้อนชื่อ',
	description: 'คำอธิบาย',
	descriptionInvalid: 'คำอธิบายห้ามเกิน 350 อักขระ',
	descriptionPlaceholder: 'ป้อนคำอธิบาย',
	errorMessageApostropheError: 'โปรดป้อนชื่อไฟล์ที่ไม่มีทั้งอักขระ \' และ "',
	renameCollisionError: '%{name} มีอยู่แล้ว โปรดลองใช้ชื่ออื่น',
	unknownRenameError: 'การเปลี่ยนชื่อไอเท็มล้มเหลว โปรดติดต่อผู้ดูแลระบบสำหรับความช่วยเหลือเพิ่มเติม',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'ไม่สามารถเปิดโฟลเดอร์ที่ระบุ',

	//Upload
	uploadToFolder: "อัพโหลดไปยัง <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "อัพโหลดไปยัง <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> และเรียกใช้งาน%{launchAction}",
	quickUpload: "อัพโหลดแบบด่วน",
	quickUploadAndLaunch: "ลากและปล่อยไฟล์เพื่ออัพโหลดไปยัง <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> และเปิดหนึ่งในสเปซต่อไปนี้",
	unsupportedFilesSingle: "%{files} ไม่ได้อัพโหลดเนื่องจากใช้ไม่ได้สำหรับการเรียกใช้งานแบบด่วน",
	unsupportedFilesMultiple: "ไฟล์ไม่ได้อัพโหลดเนื่องจากไฟล์ทั้งหมดที่คุณเลือกต้องใช้ได้สำหรับการเรียกใช้งานด่วน",
	unsupportedFilesSingleInvalid: "%{files} ไม่ถูกต้อง",
	unsupportedFilesMultipleInvalid: "%{files} ไม่ถูกต้อง",
	supportedFileTypes: "อนุญาตให้ใช้ไฟล์ชนิดต่อไปนี้เท่านั้น: %{extensions}",
	uploadDragAndDrop: "ลากและปล่อย",
	uploadDragAndDropMessage: "ลากและปล่อยไฟล์ของคุณที่นี่เพื่ออัพโหลดไปยัง <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'เกณฑ์การค้นหา \'%{searchTerm}\' ถูกบันทึกแล้ว',
	searchWasntSaved: 'เกณฑ์การค้นหา \'%{searchTerm}\' ยังไม่ถูกบันทึก',
	searchSuggestions: 'ข้อเสนอแนะ',
	savedSearch: 'การค้นหาที่บันทึกไว้',
	searchWasDeleted: 'เกณฑ์การค้นหา \'%{searchTerm}\' ถูกลบแล้ว',
	searchWasntDeleted: 'เกณฑ์การค้นหา \'%{searchTerm}\' ยังไม่ถูกลบ',
	savedBarTitle: 'ค้นหา Cognos Analytics',
	searchContentPageTitle: 'ค้นหา',
	searchContentPageTitleLabel: 'กำลังแสดงผลลัพธ์สำหรับ \'%{searchTerm}\'',
	showingSearchRsult: 'กำลังแสดง %{resultCount} ไอเท็ม',
	saveSearch: 'บันทึกการค้นหา',
	saveTenSearches: 'คุณสามารถบันทึก 10 การค้นหา',
	deleteASearch: 'ลบหนึ่งการค้นหา เพื่อบันทึกการค้นหาอื่น',
	close: 'ปิด',
	allContent: 'เนื้อหาทั้งหมด',
	searchResultIn: 'ผลการค้นหาใน ',
	//recent view
	recents: 'เมื่อเร็ว ๆ นี้',
	noAccessRecent: 'ไม่มีการเข้าถึง',
	noAccessRecentMsg: 'คุณไม่มีสิทธิ์เข้าถึงกับทรัพยากรนี้ อาจปิดใช้งานอยู่หรือลบออกแล้ว หรือสิทธิ์ของคุณอาจถูกลดลง ตรวจสอบสถานะของทรัพยากรที่ตำแหน่งต้นทางที่ต้องการ คุณสามารถลบสินทรัพย์ออกจากไอเท็มล่าสุดได้โดยการคลิก ตกลง',
	noAccessMsg: 'คุณไม่มีสิทธิ์เข้าถึงกับทรัพยากรนี้ อาจปิดใช้งานอยู่หรือลบออกแล้ว หรือสิทธิ์ของคุณอาจถูกลดลง',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} ไอเท็มที่เลือก',
	itemSelected: '%{nameOfSelection} ไอเท็มที่เลือก',

	//properties
	general: 'ทั่วไป',
	schedule: 'กำหนดการ',
	permission: 'การอนุญาต',
	capabilities: 'ความสามารถ',
	propertiesTabsLabel: 'เนื้อหาคุณสมบัติ',
	searchPath: 'พาธการค้นหา',
	id: 'ID',
	language: 'ภาษา',
	setLanguage: 'ตั้งค่าภาษา',
	entryOptions: 'ตัวเลือกรายการ',
	setPackage: 'ตั้งค่าแพ็กเกจหรือโมดูล',
	sourcePackage: 'แพ็กเกจต้นทางหรือโมดูลข้อมูล',
	associatedSourceAgent: 'แพ็กเกจต้นทาง',
	setAssociatedSourceAgent: 'ตั้งค่าแพ็กเกจ',
	sourceAgent: 'เอเจนต์ต้นทาง',
	setSourceAgent: 'ตั้งค่าเอเจนต์ต้นทาง',
	setCapabilities: 'ตั้งค่าความสามารถ',
	disableEntry: 'ปิดใช้งานรายการนี้',
	hideEntry: 'ซ่อนรายการนี้',
	permissions: 'การอนุญาต',
	promptForValues: 'พร้อมต์สำหรับค่า',
	yes: 'ใช่',
	no: 'ไม่',
	setValues: 'ตั้งค่า',
	moreOptions: 'ตัวเลือกเพิ่มเติม',
	reportFormat: 'รูปแบบรายงาน',
	enableAccessibilitySupport: 'เปิดใช้การสนับสนุนความสามารถในการเข้าถึง',
	displayOfRunHistory: 'การแสดงของประวัติการรัน',
	occurrences: 'เหตุการณ์ที่เกิดขึ้น',
	days: 'วัน',
	months: 'เดือน',
	displayOfReportOutputVersions: 'การแสดงเวอร์ชันเอาต์พุตของรายงาน',
	defaultDisplayOfPortalAction: 'การดำเนินการพอร์ทัลดีฟอลต์',
	viewMostRecentReport: 'ดูรายงานล่าสุด',
	runTheReport: 'รันรายงาน',
	openWithReportStudio: 'เปิดด้วย Report Studio',
	rowsPerPageInHtmlReports: 'แถวต่อหน้าในรายงาน HTML',
	enableSelectionBasedInteractivity: 'เปิดใช้งานการโต้ตอบตามตัวเลือก',
	enableAlertsAboutNewVersions: 'เปิดใช้งานการเตือนเกี่ยวกับเวอร์ชันใหม่',
	enableEnhancedUserFeaturesInSavedOutputVersions: 'เปิดใช้งานคุณลักษณะผู้ใช้ที่ปรับปรุงแล้วในเวอร์ชันเอาต์พุตที่บันทึกไว้',
	enableCommentsInSavedOutputVersions: 'เปิดใช้งานความคิดเห็นในเวอร์ชันเอาต์พุตที่บันทึกไว้',
	run: 'ดำเนินงาน',
	runWithUsersCredentials: 'ด้วยหนังสือรับรองของผู้ใช้',
	runWithOwnerCapabilities: 'ด้วยความสามารถของเจ้าของ',
	runAsOwner: 'ในฐานะ %{ownerName}',
	actionLabelOn: 'เปิด',
	actionLabelOff: 'ปิด',
	openReport: 'แก้ไข',
	openAnalysis: 'เปิดด้วย Analysis Studio',
	openQuery: 'เปิดด้วย Query Studio',
	openPowerPlay8Report: 'เปิดด้วย PowerPlay Studio',
	openInteractiveReport: 'แก้ไข',
	read: 'อ่าน',
	write: 'เขียน',
	execute: 'ดำเนินการ',
	setPolicy: 'กำหนดนโยบาย',
	full: 'เต็ม',
	traverse: 'สำรวจ',
	grant: 'อนุญาต',
	deny: 'ปฏิเสธ',
	permissionCustom: 'กำหนดเอง',
	permissionDetailsColumnAccess: 'การเข้าถึง',
	permissionDetailsColumnPermission: 'สิทธิการใช้งาน',
	permissionDetailsColumnAction: 'การดำเนินการ',
	permissionSetAccess: 'ตั้งค่าการเข้าถึง',
	permissionRead: 'อ่าน',
	permissionRun: 'รัน',
	permissionWrite: 'เขียน',
	permissionFull: 'เต็ม',
	unavailable: 'ไม่พร้อมใช้งาน',
	unkownSource: 'ไม่รู้จัก, เปิดรายงานสำหรับรายละเอียด',
	tenantSettings: 'การตั้งค่าผู้เช่า',
	tenantSet: 'ผู้เช่าที่อัพเดตแล้ว',
	tenantSetError: 'ข้อผิดพลาดขณะตั้งค่าผู้เช่า',
	tenantClear: 'ผู้เช่าถูกเคลียร์แล้ว',
	tenantClearError: 'ข้อผิดพลาดขณะเคลียร์ผู้เช่า',
	shortcutTo: 'ทางลัดไปยัง',
	sourceReport: 'รายงานต้นฉบับ',
	setSourceReport: 'ตั้งค่ารายงานต้นทาง',
	setSourceLocation: 'ตั้งค่าตำแหน่งต้นทาง %{itemName}',
	linkPackageOrModule: 'เชื่อมโยง %{itemName} กับแพ็กเกจหรือโมดูลข้อมูล',
	linkPackage: 'เชื่อมโยง %{itemName} ไปยังแพ็กเกจ',
	externalRepositories: 'ที่เก็บข้อมูลภายนอก',
	sizeByte: '%{value} B',
	sizeKiloByte: '%{value} KB',
	sizeMegaByte: '%{value} MB',
	sizeGigaByte: '%{value} GB',
	sizeTeraByte: '%{value} TB',
	sizePetaByte: '%{value} PB',
	refreshedDatetime: 'เวลาที่รีเฟรช',
	size: 'ขนาด',
	tenantsWarningMessage: 'การเปลี่ยนผู้เช่าของรายการยังเปลี่ยนผู้เช่าของรายการชายน์ด้วย',
	confirmClearTenantText: 'การล้างค่าเป็น \'ไม่มี\' อาจอนุญาตให้ผู้เช่ารายอื่นเข้าถึงเนื้อหาได้ คลิก ตกลง เพื่อทำรายการเป็นแบบพับลิกหรือ ยกเลิก เพื่อเก็บผู้เช่าปัจจุบัน',
	confirmClearTenant: 'ยืนยันการเคลียร์ผู้เช่า',
	currentValues: 'ค่าปัจจุบัน',
	emptyPromptValues: 'ไม่มีค่าอยู่ในปัจจุบัน',
	editValues: 'แก้ไขค่า',
	clear: 'ล้าง',
	source: 'ซอร์ส',
	dataRefreshed: 'รีเฟรชข้อมูลแล้ว',
	//PDF options
	pdfOptions: 'อ็อพชัน PDF',
	set: 'ชุดข้อมูล',
	portrait: 'แนวตั้ง',
	landscape: 'แนวนอน',
	letter: 'ตัวอักษร',
	legal: 'ถูกกฎหมาย',
	elevenxSeven: '11x17',
	A3: 'A3',
	A4: 'A4',
	b4jis: 'B4JIS',
	b5jis: 'B5JIS',
	orientation: 'การจัดวาง',
	pageDefination: 'ขนาดกระดาษ',
	openPasswordRequired: 'ต้องใช้รหัสผ่านเพื่อเปิดรายงาน',
	accessPasswordRequired: 'ต้องใช้รหัสผ่านเพื่อเข้าถึงรายงาน',
	emptyPassword: 'รหัสผ่านต้องไม่เว้นว่าง',
	password: 'รหัสผ่าน',
	enterPassword: 'ป้อนรหัสผ่าน',
	confirmPassword: 'ยืนยันรหัสผ่าน',
	passwordMatchError: 'รหัสผ่านไม่ตรงกัน',
	gateway: 'เกตเวย์',
	pageLayout: 'เค้าโครงหน้า',
	pageStyle: 'สไตล์',
	setUrl: 'ตั้งค่า URL',
	numberRows: 'จำนวนแถว',
	numberColumns: 'จำนวนของคอลัมน์',
	timeToRefresh: 'เวลาที่ต้องรีเฟรช',
	lastRefreshedBy: 'รีเฟรชโดย',
	unknown: 'ไม่รู้จัก',
	unknownUpdateError: 'อัพเดตไอเท็มล้มเหลว โปรดติดต่อผู้ดูแลระบบสำหรับความช่วยเหลือเพิ่มเติม',
	editQuery: 'แก้ไขเคียวรี',
	greaterOrEqual: 'มากกว่าหรือเท่ากับ %{upperboundValue}',
	lessOrEqual: 'น้อยกว่าหรือเท่ากับ %{lowerboundValue}'
});
